import React from 'react'
import { BCol, BLine, BLink, BRow, BText, BTitle } from '@prague-digi/ui-components'

import { PageControlButtons } from '../../../../components'
import { intl, IntlInterface } from '../../../../hoc'
import { SUPPORT_PHONE } from '../../../../constants/commonConstants'
import bankBranch from '../../../../assets/bankBranch.svg'
import messages from '../../../../i18n'
import phoneIcon from '../../../../assets/phoneRinging.svg'

interface Props extends IntlInterface {
  canFinishInIB: boolean
  canFinishOnline: boolean
  commitReScoring: Function
  finishIb: Function
  finishBranch: Function
  finishOnline: Function
  isRescoring: boolean
}

export const Footer: React.FC<Props> = ({
  canFinishInIB,
  canFinishOnline,
  isRescoring,
  finishBranch,
  finishIb,
  commitReScoring,
  translate,
  translateHTML,
  finishOnline,
}: Props) =>
  isRescoring ? (
    <PageControlButtons
      onSubmit={commitReScoring}
      submitMessage={messages.common.continue}
      testId="commitReScoring"
    />
  ) : (
    <>
      {canFinishInIB && (
        <PageControlButtons
          onSubmit={finishIb}
          submitMessage={messages.loanConfigurator.footer.finishIb}
          testId="finishIb"
        />
      )}
      {canFinishOnline && (
        <PageControlButtons
          onSubmit={finishOnline}
          submitMessage={messages.loanConfigurator.footer.finishOnline}
          testId="finishOnline"
        />
      )}

      <BLine theme="mt-5" />

      <BRow theme="mt-5">
        <BCol lg={6} md={6} sm={12} xs={12} theme="text-center">
          <img alt="phone" height="40" src={phoneIcon} />
          <BText center type="info" theme="mt-3">
            {translateHTML(messages.loanConfigurator.footer.callUs)}
          </BText>
          <BLink href={`tel:${SUPPORT_PHONE}`}>
            <BTitle type="h4" theme="text-info">
              {SUPPORT_PHONE}
            </BTitle>
          </BLink>
        </BCol>

        <BCol lg={6} md={6} sm={12} xs={12} theme="text-center">
          <img alt="branch" height="40" src={bankBranch} />
          <BText center type="info" theme="mt-3">
            {translateHTML(messages.loanConfigurator.footer.visitUs)}
          </BText>
          <BLink onClick={finishBranch}>
            <BTitle type="h4" theme="text-info">
              {translate(messages.loanConfigurator.footer.visitUsLink)}
            </BTitle>
          </BLink>
        </BCol>
      </BRow>
    </>
  )

export default intl(Footer)
